import React from 'react';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import { ViewDocument } from '../../../../components';
import arrayMove from 'array-move';

const SortableItem = SortableElement(({ value }) => (
  <li style={{ textAlign: 'left', padding: 20, backgroundColor: 'white', marginTop: '20px' }}>
    {value.answerText && <p>{value.answerText}</p>}

    {
      value.files && value.files.length > 0 &&
      <ViewDocument files={value.files} />
    }
    {value.answerHtml && (
      <p
        style={{ wordWrap: 'break-word' }}
        dangerouslySetInnerHTML={{ __html: value.answerHtml }}
      />
    )}
  </li>
));

const SortableList = SortableContainer(({ items }) => {
  return (
    <ul>
      {items.map((value, index) => (
        <SortableItem key={`item-${value.id}`} index={index} value={value} />
      ))}
    </ul>
  );
});

const Question3 = ({ data, setData }) => {

  const onSortEnd = ({ oldIndex, newIndex }) => {
    const newArray = arrayMove([...data.answerVariants], oldIndex, newIndex);
    setData({ ...data, answerVariants: [...newArray] });
  };

  return (
    <div>
      <SortableList items={[...data.answerVariants]} onSortEnd={onSortEnd} />
    </div>
  );
};

export default Question3;
